import React__default from 'react';
import { FilterContainer } from '../FilterContainer/index.js';
import styles from 'ui-components/FilterMenu/FilterBucket.scss';

var FilterBucket = function FilterBucket(_ref) {
  var openFilter = _ref.openFilter,
    setOpenFilter = _ref.setOpenFilter,
    filter = _ref.filter,
    onValueClick = _ref.onValueClick,
    activeFilters = _ref.activeFilters,
    CheckmarkIcon = _ref.CheckmarkIcon,
    ChevronIcon = _ref.ChevronIcon;
  var activeBucketFilters = activeFilters && activeFilters.filter(function (af) {
    return af.code === filter.code;
  });
  return /*#__PURE__*/React__default.createElement(FilterContainer, {
    openFilter: openFilter,
    setOpenFilter: setOpenFilter,
    filterName: filter.label,
    ChevronIcon: ChevronIcon,
    activeFilterValue: activeBucketFilters
  }, filter.values.map(function (v) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: v.value,
      className: styles.value,
      onClick: function onClick() {
        return onValueClick({
          code: filter.code,
          value: v.value
        });
      }
    }, /*#__PURE__*/React__default.createElement("span", null, v.value), activeBucketFilters.length > 0 && activeBucketFilters.find(function (f) {
      return f.value === v.value;
    }) && /*#__PURE__*/React__default.createElement(CheckmarkIcon, {
      className: styles.checkmark
    }));
  }));
};

export { FilterBucket };
//# sourceMappingURL=index.js.map
